import App from "./component/app/App.svelte";

const app = new App({
  target: document.body,
  props: {
    name: "Svelte"
  }
});
export default app;
